
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"0 0 33 35","fill":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('image',{attrs:{"width":"33","height":"35","data-name":"Vector Smart Object copy 23","xlink:href":"data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAACEAAAAjCAQAAACwJavvAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QAAKqNIzIAAAAJcEhZcwAACxIAAAsSAdLdfvwAAAAHdElNRQfkBwcLGxWmSNcNAAACGElEQVRIx8WVMWhTURSG/5tGk2Bpo42SxrrooAbcHCyClIK0ipoOWmtEBOkouIoUglDQShWkIHQySzsIah26OCtkqEotZqiDQ2m0LcZSi7YgfA7G2Cb3pnnJ4LvL5Zz/fffe8+75n5BjdDLLJYRo5jEZp06uRAd5ehHCMMUYLd4Rw9wtzGKs4XMD3IgEOY4jRAOz3CPoHSEus8g4uxBtvOQT3d4RIkyaNxiE6OErnd4RwvCDvYX5He57R4R4SLZQyg6+cMor4gxzTNKKiPCEBS56rUUXS5xGCB/vGaXpv9yLbhbpKuziA49orOVe9DDPU4TYw3NyHKvlXuzgQnF+gv0unUH1Pr66CfJruV6EAcX0s+b3Q8r5taCAPlclv6GdZbGwvvn0UfEqV7TVbbfmDcNa00DNBxlU0HBSD3SkgqhNz7Tdmd2nPoNfczqrKaeoQe3yO3IHNahWg5TSYfVtueWAQmWxUWV1+4/BLdFe0b2EGGO5ZHxnlfDfHuknS2hLSKmnZen/1yNGL7SiK8J6gPPaVhY16tUvnRMqtlmTXmtSNy2IqEYsiLgadUgrkjY0e5QZ0pV+OcURJM0MUVuzhzWumK7prfWLHNCAjKQWHdU7JTe05ya+j+vkSRO3rN3MVW7xilVGNntpuTTCEHkyJEviSTLkGSJSnfEFSDFREpsgRcCmtrvWuqYt0Wmt28Ru40uULJZwCX8DOVkOmYCvreoAAAAASUVORK5CYII="}})])
          )
        }
      }
    